import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row } from 'reactstrap';

class MySanta extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    return (
      <Row className='cr_an'><img src={this.props.imageSanta} style={{ top: `${this.props.top}`,  left: `${this.props.left}` }}  alt="Santa" /></Row>
    );
  }
}
MySanta.propTypes = {
  imageSanta: PropTypes.any,
  top: PropTypes.any,
  left: PropTypes.any
};
export default MySanta